<template>
  <div id="storeEdit">
    <div class="commonContainer">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-upload
            class='avatar-uploader'
            :action="attachmentsUploadUrl"
            :show-file-list='false'
            :on-success='cropUploadSuccess'
            :on-error="errorCallback"
            :headers="header"
            accept=".jpg,.png,.jpeg"
          >
            <img v-if='logoImage' :src='logoImage' class='avatar'>
            <i v-else class='el-icon-plus avatar-uploader-icon'></i>
          </el-upload>
        </el-col>
        <el-col :span="6">
          <i class="location el-icon-location"></i>
          <div class="store-info">
            <p class="store-name">{{ detail.doorName }}<br/>{{detail.posId}}</p>
            <p class="store-detail">{{detail.regionName}}/{{detail.provinceName}}/{{detail.cityName}}/{{detail.resellerName}}</p>
          </div>
        </el-col>
        <el-col :span="6">

        </el-col>
      </el-row>
      <div class="store-detail-list">
        <div class="a-box" v-for="item in detail.attributes">
          <h4>{{item.name}}</h4>
          <el-card shadow="never" class="card" v-if="item.subAttributes.length">
            <div class="content">
              <el-descriptions :column="1" v-for="subItem in item.subAttributes" :key="subItem.id">
                <el-descriptions-item :label="subItem.name" label-class-name="my-label" content-class-name="my-content">{{subItem.value}}</el-descriptions-item>
              </el-descriptions>
            </div>
          </el-card>
          <el-card shadow="never" class="card" v-if="!item.subAttributes.length">
            <p class="content">{{ item.value }}</p>
          </el-card>
        </div>
      </div>
    </div>

    <el-row type="flex" class="row-bg" justify="space-around" style="margin-top: 50px; margin-bottom: 80px;">
        <el-col :span="6">
          <div class="center">
            <el-button type="plain" @click="goBack">{{ $t('close') }}</el-button>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="center">
            <el-button type="primary" @click="save()">{{ $t('save') }}</el-button>
          </div>
        </el-col>
      </el-row>
  </div>
</template>

<script>
import _ from 'lodash'
import anyImageUpload from "@/components/anyImageUpload";
import { deprecationHandler } from 'moment';

export default {
  name: 'TaskEdit',
  components: {
    anyImageUpload
  },
  data: function () {
    return {
      header: {
        token: CookieManage.get('token') || '', // 用户token
      },
      attachmentsUploadUrl: window.uploadUrl,
      logoImage: '',
      doorNo: this.$route.query.doorNo || null,
      detail: {}
    }
  },
    

  mounted () {
    this.getDetail();
  },

  

  methods: {

    // 获取详情
    async getDetail() {
      let res = await window.instance.post(topdoorReqUrl + '/door/detail/' + this.doorNo)
      console.log('res', res.data)
      res = res.data
      if (res.code === 200) {
        this.detail = res.data || {}
        this.logoImage = res.data.image
      } else {
        this.$message.error(res.message || '获取详情失败')
      }
      
    },

    cropUploadSuccess (jsonData, field) {
      console.log('jsonData', jsonData)
      if (jsonData.code === 200) {
        this.logoImage = jsonData.data.url
      } else {
        this.$message.error(jsonData.message)
      }

    },
    errorCallback (error) {
      console.log('上传图片错误',error)
    },
    resetFilters: function () {
      this.getRangeList()
    },

    goBack() {
      window.close()
    },

    // 保存
    async save() {
      let param = {
        doorNo: this.doorNo,
        image: this.logoImage||''
      }
      let res = await window.instance.post(topdoorReqUrl + '/door/save', param)
      console.log('res', res.data)
      res = res.data
      if (res.code === 200) {
        this.$message.success(res.message)
        //window.close()
      } else {
        this.$message.error(res.message)
      }
      
    },


  }
}
</script>
<style lang="sass">
.my-label
  color: #8c939d
.my-content
  color: #272727
</style>
<style scoped lang="sass">
.operations
  float: right
  color: #ff6801
  font-size: 14px
  margin: -30px 0 0 90px
  span
    margin-right: 20px
#storeEdit
  .location
    font-size: 20px
    float: left
    margin-top: 12px
  .store-info
    margin-left: 26px
  .store-name
    margin-top: 12px
    font-size: 14px

  .store-detail
    margin-top: 12px
    color: #606266
    font-size: 14px

  .avatar-uploader .el-upload
    border: 1px dashed #d9d9d9
    border-radius: 6px
    cursor: pointer
    position: relative
    overflow: hidden

  .avatar-uploader .el-upload:hover
    border-color: #409EFF


  .avatar-uploader-icon
    font-size: 20px
    color: #8c939d
    width: 300px
    height: 150px
    line-height: 150px
    text-align: center
    border: 1px dashed #ccc
    background: #fff
  .avatar
    width: 150px
    display: block

  .store-detail-list
    display: flex
    align-items: center
    justify-content: space-between
    flex-grow: 1
    flex-wrap: wrap
    margin-top: 30px
    .a-box
      width: 32%
      margin-bottom: 20px
      height: 250px
      overflow: auto
    .card
      height: 90%
      overflow: auto
      font-size: 14px
    .subtitle
      margin-bottom: 20px

</style>



// WEBPACK FOOTER //
// src/pages/topdoor/storeEdit.vue